var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19052_51227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 0H0V116H116V0Z",
    fill: "#445689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 87.4531C68.0102 87.4531 76.125 79.3383 76.125 69.3281C76.125 59.318 68.0102 51.2031 58 51.2031C47.9898 51.2031 39.875 59.318 39.875 69.3281C39.875 79.3383 47.9898 87.4531 58 87.4531Z",
    fill: "#445689"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5551,
    cy: 47.7778,
    r: 9.77778,
    fill: "#D0F19A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2218 74.0573L34.7773 59.3906C37.2218 56.9458 37.2218 55.523 42.1107 54.1186C46.3867 52.8902 50.6662 56.827 55.5551 61.1048C60.444 65.3825 64.7218 64.1603 67.7773 64.1603C70.2218 64.1603 71.2403 66.6048 71.444 67.827L87.3329 61.1048C89.238 61.9212 89.7164 63.4068 89.5905 64.8447C89.4061 66.9504 87.7881 68.5745 86.186 69.9533C76.7226 78.0983 65.0445 84.2789 61.6662 83.7159C58.7329 83.227 43.7403 77.1128 37.2218 74.0573Z",
    fill: "#7499D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.444 67.827L87.3329 61.1048C89.238 61.9212 89.7164 63.4068 89.5905 64.8447C89.4061 66.9504 87.7881 68.5745 86.186 69.9533C76.7226 78.0983 65.0445 84.2789 61.6662 83.7159C58.7329 83.227 43.7403 77.1128 37.2218 74.0573L34.7773 59.3906C37.2218 56.9458 37.2218 55.523 42.1107 54.1186C46.3867 52.8902 50.6662 56.827 55.5551 61.1048C60.444 65.3825 64.7218 64.1603 67.7773 64.1603C70.2218 64.1603 71.2403 66.6048 71.444 67.827ZM71.444 67.827C70.9259 68.9926 68.9914 70.8006 66.1432 71.7116C62.4883 72.8805 58.4622 72.3267 54.7295 71.4367C52.7845 70.973 50.8516 70.2222 49.444 69.0492",
    stroke: "#445689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.686 80.5898C29.1292 80.6942 28.5969 80.3156 28.5128 79.7553L25.1413 57.2786C25.0622 56.751 25.4111 56.2543 25.9341 56.1497L33.1621 54.7041C33.7129 54.5939 34.2464 54.9589 34.3433 55.5123L38.2741 77.9744C38.3685 78.5138 38.0116 79.0288 37.4734 79.1297L29.686 80.5898Z",
    fill: "#D0F19A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.469 51.7721C65.8446 51.7721 65.3673 51.604 65.0371 51.2678C64.7069 50.9256 64.5418 50.4333 64.5418 49.7908V48.539C65.1061 48.539 65.5564 48.524 65.8926 48.494C66.2289 48.464 66.478 48.3979 66.6401 48.2959C66.8082 48.1878 66.9163 48.0317 66.9643 47.8276C67.0184 47.6234 67.0454 47.3443 67.0454 46.99V45.7652H68.054V46.981C68.054 47.3833 68.012 47.7285 67.928 48.0167C67.8499 48.3049 67.7148 48.542 67.5227 48.7282C67.3306 48.9143 67.0724 49.0524 66.7482 49.1424C66.43 49.2265 66.0337 49.2685 65.5594 49.2685V49.8899C65.5594 50.2021 65.6255 50.4573 65.7575 50.6554C65.8896 50.8475 66.1238 50.9436 66.46 50.9436C66.7662 50.9436 66.9853 50.8535 67.1174 50.6734C67.2555 50.4933 67.3246 50.2411 67.3246 49.9169H68.3332C68.3152 50.5113 68.1471 50.9706 67.8289 51.2948C67.5167 51.613 67.0634 51.7721 66.469 51.7721ZM64.2446 47.6384V46.936H69.0717V47.6384H64.2446ZM64.2446 46.1075V45.36H69.0717V46.1075H64.2446Z",
    fill: "#445689"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19052_51227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/General.66e1cb89880b813c02c849491e61678e.svg";
export { ForwardRef as ReactComponent };